/* eslint-disable import/prefer-default-export */
import store from '@/store'
import { getData } from '@core/utils/http/general'

export const LoadResumen = (mtrl, plan = 1) => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 37,
    mtrl,
    plan,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wscompras')
    .then(response => {
      if (response.status === 500) {
        reject(response.data.message)
      } else resolve(response.data)
    })
    .catch(err => { reject(err) })
})
